<template>
    <div>
        <vxe-form :data="toolbar.formData">
            <vxe-form-item title="变更类型" :item-render="{}">
                <template #default="{ data }">
                    <vxe-select
                        v-model="data.changeType"
                        placeholder="全部"
                        style="width: 120px"
                        @change="findData"
                    >
                        <vxe-option value="1" label="频率变更" />
                        <vxe-option value="2" label="类型变更" />
                    </vxe-select>
                </template>
            </vxe-form-item>
            <vxe-form-item title="状态" :item-render="{}">
                <template #default="{ data }">
                    <vxe-select
                        v-model="data.status"
                        placeholder="全部"
                        clearable
                        style="width: 120px"
                        @change="findData"
                    >
                        <vxe-option value="0" label="未提交" />
                        <vxe-option value="1" label="CoE审核中" />
                        <vxe-option value="2" label="已审核" />
                        <vxe-option value="3" label="已驳回" />
                    </vxe-select>
                </template>
            </vxe-form-item>
            <vxe-form-item title="总部" :item-render="{}">
                <template #default="{ data }">
                    <vxe-select
                        style="width: 140px"
                        transfer
                        v-model="data.division"
                        :options="formInput.hqOptions"
                        placeholder="全部"
                        clearable
                    />
                </template>
            </vxe-form-item>

            <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
                <template #default="{ data }">
                    <vxe-input
                        v-model="data.searchKey"
                        placeholder="请输入数字员工编号、数字员工名称、开发编号"
                        clearable
                        @keyup.enter="findData"
                    />
                </template>
            </vxe-form-item>

            <vxe-form-item>
                <template #default>
                    <vxe-button status="primary" @click="findData">
                        查询
                    </vxe-button>
                    <vxe-button @click="clear">重置</vxe-button>
                    <vxe-button @click="exportDataEvent">导出</vxe-button>
                </template>
            </vxe-form-item>
        </vxe-form>

        <div style="overflow: hidden; height: 100%">
            <!-- 频率变更表 -->
            <vxe-table
                v-if="toolbar.formData.changeType !== '2'"
                stripe
                ref="xTable1"
                class="mytable-scrollbar"
                :data="historyDataFrequency"
                :height="tableHeight"
                show-overflow
                :loading="toolbar.loading"
                :row-config="{
                    height: 36,
                    isHover: true,
                    isCurrent: true,
                }"
            >
                <vxe-column type="seq" title="序号" width="50" />

                <vxe-column field="statusName" title="状态" width="120">
                    <template #default="{ row }">
                        <vxe-button
                            :class="{
                                active: row.statusName === '已审核',
                                error: (row.statusName || '').includes('驳回'),
                            }"
                            type="text"
                            @click="showAuditList(row)"
                        >
                            {{ row.statusName }}
                        </vxe-button>
                    </template>
                </vxe-column>

                <vxe-column
                    field="ProcessName"
                    title="数字员工名称"
                    width="180"
                />
                <vxe-column field="ProcessID" title="开发编号" width="130" />
                <vxe-column
                    field="division"
                    title="总部"
                    width="100"
                    show-overflow
                />
                <vxe-column
                    field="realPlatformName"
                    title="部署平台"
                    width="120"
                    show-overflow
                />
                <vxe-column
                    field="oldManSingleTime"
                    title="原人工每次耗时"
                    width="150"
                />
                <vxe-column
                    field="ManSingleTime"
                    title="新人工每次耗时"
                    width="150"
                />
                <vxe-column
                    field="oldManFrequency"
                    title="原人工每月次数"
                    width="150"
                />
                <vxe-column
                    field="ManFrequency"
                    title="新人工每月次数"
                    width="150"
                />
                <vxe-column
                    field="oldDevelopTime"
                    title="原开发时长"
                    width="150"
                />
                <vxe-column
                    field="DevelopTime"
                    title="新开发时长"
                    width="150"
                />
                <vxe-column
                    field="oldRobotSingleTime"
                    title="原机器人单次耗时"
                    width="150"
                />
                <vxe-column
                    field="RobotSingleTime"
                    title="新机器人单次耗时"
                    width="150"
                />
                <vxe-column
                    field="oldRobotMonthRun"
                    title="原机器人每月次数"
                    width="150"
                />
                <vxe-column
                    field="RobotMonthRun"
                    title="新机器人每月次数"
                    width="150"
                />
                <vxe-column
                    field="creationTime"
                    title="创建日期"
                    width="150"
                    :formatter="formatTime"
                />
                <vxe-column field="UserName" title="申请人" width="100" />
                <vxe-column
                    field="changeReason"
                    title="变更原因"
                    min-width="200"
                />
            </vxe-table>

            <!-- 类型变更表 -->
            <vxe-table
                v-if="toolbar.formData.changeType === '2'"
                stripe
                ref="xTable2"
                class="mytable-scrollbar"
                :data="historyDataEmpType"
                :height="tableHeight"
                show-overflow
                :loading="toolbar.loading"
                :row-config="{
                    height: 36,
                    isHover: true,
                    isCurrent: true,
                }"
            >
                <vxe-column type="seq" title="序号" width="50" />

                <vxe-column field="statusName" title="状态" width="120">
                    <template #default="{ row }">
                        <vxe-button
                            :class="{
                                active: row.statusName === '已审核',
                                error: (row.statusName || '').includes('驳回'),
                            }"
                            type="text"
                            @click="showAuditList(row)"
                        >
                            {{ row.statusName }}
                        </vxe-button>
                    </template>
                </vxe-column>

                <vxe-column
                    field="ProcessName"
                    title="数字员工名称"
                    width="180"
                />
                <vxe-column field="ProcessID" title="开发编号" width="130" />
                <vxe-column
                    field="division"
                    title="总部"
                    width="100"
                    show-overflow
                />
                <vxe-column
                    field="realPlatformName"
                    title="部署平台"
                    width="120"
                    show-overflow
                />
                <vxe-column
                    field="oldempTypeName"
                    title="原数字员工类型"
                    width="150"
                />
                <vxe-column
                    field="empTypeName"
                    title="新数字员工类型"
                    width="150"
                />

                <vxe-column title="附件" width="100">
                    <template #default="{ row }">
                        <vxe-button type="text" @click="downloadFile(row)">
                            下载
                        </vxe-button>
                    </template>
                </vxe-column>

                <vxe-column
                    field="creationTime"
                    title="创建日期"
                    width="150"
                    :formatter="formatTime"
                />
                <vxe-column field="UserName" title="创建人" width="100" />
                <vxe-column
                    field="changeReason"
                    title="变更原因"
                    min-width="200"
                />
            </vxe-table>
        </div>

        <vxe-pager
            background
            v-model:current-page="tablePager.currentPage"
            v-model:page-size="tablePager.pageSize"
            :total="tablePager.totalResult"
            @page-change="handlePageChange"
            :page-sizes="[10, 20, 100, { label: '全部数据', value: 10000 }]"
            :layouts="[
                'PrevJump',
                'PrevPage',
                'JumpNumber',
                'NextPage',
                'NextJump',
                'Sizes',
                'FullJump',
                'Total',
            ]"
        />
    </div>
    <vxe-modal
        title="审核记录"
        v-model="isShowAuditList"
        width="500"
        height="600"
    >
        <template #default>
            <div>
                <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted } from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";
const { proxy } = getCurrentInstance();

const tableHeight = ref(350);

const historyDataFrequency = ref([]);
const historyDataEmpType = ref([]);
const dtAudit = ref([]);
const isShowAuditList = ref(false);
const tablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});

const toolbar = reactive({
    loading: false,
    formData: {
        division: "",
        status: "",
        changeType: "1",
        searchKey: "",
    },
});

const formInput = reactive({
    hqOptions: [],
    planPlatform: [],
});

const formatTime = ({ cellValue }) => {
    if (!cellValue) {
        return "";
    }
    return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
};

const findData = () => {
    toolbar.loading = true;

    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: tablePager.currentPage,
        pageSize: tablePager.pageSize,
        searchKey: [
            "",
            toolbar.formData.changeType,
            toolbar.formData.division,
            toolbar.formData.status,
            toolbar.formData.searchKey,
        ],
    };

    proxy.$api.newPublishManageAPI
        .getPublishInfoChange(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }

            const result = res.data.Data || {};
            const rows = result.dataTable || [];

            if (toolbar.formData.changeType === "1") {
                historyDataFrequency.value = rows;
                historyDataEmpType.value = [];
            } else if (toolbar.formData.changeType === "2") {
                historyDataEmpType.value = rows;
                historyDataFrequency.value = [];
            } else {
                historyDataFrequency.value = rows.filter(
                    (x) => x.changeType === "1"
                );
                historyDataEmpType.value = rows.filter(
                    (x) => x.changeType === "2"
                );
            }

            tablePager.currentPage = result.currentPage;
            tablePager.pageSize = result.pageSize;
            tablePager.totalResult = result.totalResult || 0;

            const rowsLength =
                toolbar.formData.changeType === "2"
                    ? historyDataEmpType.value.length
                    : historyDataFrequency.value.length;

            tableHeight.value = calTableHeight(rowsLength);
        })
        .catch((error) => {
            console.log(error);
            VXETable.modal.message({
                content: "查询失败，请检查接口或网络",
                status: "error",
            });
        })
        .finally(() => {
            toolbar.loading = false;
        });
};

const handlePageChange = (params) => {
    tablePager.currentPage = params.currentPage;
    tablePager.pageSize = params.pageSize;
    findData();
};
const exportDataEvent = () => {
    if (toolbar.formData.changeType === "2") {
        const $table = proxy.$refs.xTable2;
        $table.exportData({ type: "csv" });
    } else {
        const $table = proxy.$refs.xTable1;
        $table.exportData({ type: "csv" });
    }
};
const clear = () => {
    toolbar.formData.division = "";
    toolbar.formData.status = "";
    toolbar.formData.changeType = "1";
    toolbar.formData.searchKey = "";
    tablePager.currentPage = 1;
    findData();
};

const calTableHeight = (rowsLength) => {
    const minHeight = window.innerHeight - (65 + 28 + 198);
    const calHeight = rowsLength == null ? 350 : (rowsLength + 1) * 36 + 30;
    return Math.max(minHeight, calHeight);
};

const showAuditList = (row) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 1,
        searchKey: [row.Id, "1"], //
    };
    proxy.$api.requireManageAPI
        .getAuditRecordList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtAudit.value = res.data.Data;
            isShowAuditList.value = true;
        })
        .catch((error) => {
            console.log(error);
        });
};

const downloadFile = (row) => {
    proxy.$api.fileManageAPI
        .downloadPublishFile(
            Qs.stringify({
                publishId: row.Id,
                type: 10,
            }),
            {
                responseType: "blob",
            }
        )
        .then((res) => {
            const contentType = res.headers["content-type"] || "";

            // 如果后端返回的是 JSON，说明是错误信息
            if (contentType.includes("application/json")) {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const result = JSON.parse(reader.result);

                        VXETable.modal.alert({
                            content:
                                result.Message || result.message || "下载失败",
                            status: "error",
                        });
                    } catch (e) {
                        VXETable.modal.alert({
                            content: "下载失败",
                            status: "error",
                        });
                    }
                };

                reader.readAsText(res.data);
                return;
            }

            let fileName = "下载文件";

            const disposition =
                res.headers["content-disposition"] ||
                res.headers["Content-Disposition"];

            if (disposition) {
                const utf8Match = disposition.match(
                    /filename\*=UTF-8''([^;]+)/i
                );
                const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (normalMatch && normalMatch[1]) {
                    fileName = decodeURIComponent(normalMatch[1]);
                }
            }

            const blob = new Blob([res.data], {
                type: contentType || "application/octet-stream",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.log(error);

            VXETable.modal.alert({
                content: "文件下载失败",
                status: "error",
            });
        });
};
const bindPlatform = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getDeployPlatformList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            formInput.planPlatform = [];
            for (const item of res.data.Data.dataTable) {
                formInput.planPlatform.push({
                    value: item.code,
                    label: item.name,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindHQ = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 50,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getHeadquarterList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            // console.log(res.data.Data);
            formInput.hqOptions = [];
            for (const item of res.data.Data.dataTable) {
                formInput.hqOptions.push({
                    value: item.hqCode,
                    label: item.hqName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

onMounted(() => {
    bindHQ();
    bindPlatform();
    findData();
});
</script>

<style lang="scss" scoped>
.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
